import { resolveClubSportDisplay } from '@/features/clubs/lib/resolveClubSportDisplay'

import type { ClubLeaderboardRow } from './types'
import type { ClubsLeaderboardApiEntry } from './types-api'

export function entryToRow(
  entry: ClubsLeaderboardApiEntry
): ClubLeaderboardRow {
  const sportDisplay = resolveClubSportDisplay({
    sport: entry.club.sport,
    sport_type: entry.club.sport_type
  })

  return {
    rank: entry.rank,
    clubId: entry.club.id,
    clubName: entry.club.name,
    logoUrl: entry.club.logo_url ?? undefined,
    country: entry.club.country,
    sportName: sportDisplay?.name,
    sportIconUrl: sportDisplay?.iconUrl,
    fans: entry.fans ?? 0,
    arenaPoints: entry.ap_score ?? 0,
    totalViews: entry.total_views ?? 0,
    isVerified: entry.club.is_verified === true
  }
}
